module.exports = __webpack_public_path__ + "static/img/09.79f247e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/09.png
// module id = etGj
// module chunks = 1